// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('dispatchPlanningBlockOrder', {
//         templateUrl: 'views/components/views/dispatchPlanningBlockOrder/dispatchPlanningBlockOrder.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'dispatchPlanningBlockOrderService', function ($stateParams, dispatchPlanningBlockOrderService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderInternalNo = $stateParams.order_internal_no;
            
//             vm.model = {
//                 itemsListBlockOrders: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadBlockOrders() {
//                 vm.model.itemsListBlockOrders = await dispatchPlanningBlockOrderService.listBlockOrders({ order_internal_no: orderInternalNo });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadBlockOrders();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
